import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { pointsTransferQueries } from '@/services/pointsTransfer/pointsTransfer.queries';

export const usePointsTransfer = () => {
  const { data, isFetched } = useQuery({
    ...pointsTransferQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data),
    }),
  });

  return { pointsTransferdata: data?.data || [], isFetched };
};
